// extracted by mini-css-extract-plugin
module.exports = {"root":"LayoutWrapperSideNav_root__2p97G","tabs":"LayoutWrapperSideNav_tabs__1k1Ol","tab":"LayoutWrapperSideNav_tab__3SNM8"};